<script lang="ts">
  import { Button, Col, Image, Row } from "sveltestrap";
  import {modalIsopen,viewModalProduct} from "../../../../store";
  import { ProductDetails } from "../../../../utils/Constant/Constant";
  import ProductSize from "./ProductSize.svelte";
  import ProductModalDetails from "./ProductModalDetails.svelte";
  let imgPath:string = "/assets/images"
  let setViewproduct:any
  viewModalProduct.subscribe((value)=>{
    setViewproduct = value
  })
  let modalOpen:boolean
  modalIsopen.subscribe((value)=>{
      modalOpen = value
  })
  function modalClose(){
      modalIsopen.update(value => value = false)
  }

</script>
<div class="modal fade {modalOpen ? "show d-block" : "d-none"}" >
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <Row class="product-box">
          <Col lg="6" class="product-img">
              <Image fluid src="{imgPath}/{setViewproduct.img}"/>
          </Col>
          <Col lg="6" class="product-details text-start">
            <h4>{setViewproduct.name}</h4>
            <div class="product-price">$ {setViewproduct.price}
              <del>$ {setViewproduct.discountPrice}</del>
            </div>
            <div class="product-view">
              <h6 class="f-w-600">{ProductDetails}</h6>
              <p class="mb-0">{setViewproduct.discription}</p>
            </div>
            <ProductSize />
            <ProductModalDetails />
          </Col>
        </Row>
        <Button class="btn-close" on:click={modalClose}></Button>
      </div>
    </div>
  </div>
</div>